import { Modal, Space } from "antd";
import { useIntl } from "react-intl";
import { useFixtureService } from "~pages/Fixtures/hooks";

interface IResetFixtureActionProperties {
  fixtureId: string;
}

export const ResetFixtureAction = (properties: IResetFixtureActionProperties) => {
  const { formatMessage } = useIntl();
  const { resetFixture, isResetPending: isResetFixtureInProcess } = useFixtureService();
  const [modal, contextHolder] = Modal.useModal();

  const onClickHandler = () => {
    modal.confirm({
      title: formatMessage({ id: "fixture.reset.title" }),
      content: formatMessage({ id: "fixture.reset.warning" }),
      okText: formatMessage({ id: "ok" }),
      cancelText: formatMessage({ id: "cancel" }),
      okButtonProps: { loading: isResetFixtureInProcess },
      onOk: () => resetFixture(properties.fixtureId),
    });
  };

  return (
    <>
      {contextHolder}
      <Space style={{ columnGap: "5px" }} onClick={onClickHandler}>
        <i className="fas fa-redo text-danger mr-2" />
        {formatMessage({ id: "fixture.reset.title" })}
      </Space>
    </>
  );
};
